import { APICore } from './apiCore'

const api = new APICore()

function getMedios (params) {
  const baseUrl = '/medios'
  return api.get(baseUrl, params)
}

function getMedio (id) {
  const baseUrl = `/medios/${id}`
  return api.get(baseUrl, {})
}

function addMedio (params) {
  const baseUrl = '/medios'
  return api.createWithFile(baseUrl, params)
}

function updateMedio (params) {
  const baseUrl = '/medios'
  return api.updateWithFile(baseUrl, params)
}

function deleteMedio (params) {
  const baseUrl = '/medios'
  return api.delete(baseUrl, params)
}

export { getMedios, getMedio, addMedio, updateMedio, deleteMedio }
